import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { ArrowPathIcon, XMarkIcon } from './icons';

export const UpdatePrompt: React.FC = () => {
    const { t } = useTranslation();

    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(_r) {
            // Optional: You could check for updates periodically here
            // console.log('SW Registered: ' + r)
        },
        onRegisterError(error) {
            console.error('SW registration error', error);
        },
    });

    const close = () => {
        setNeedRefresh(false);
    };

    return (
        <AnimatePresence>
            {needRefresh && (
                // Über dem Cookie-Hinweis (z-50), der sonst «Jetzt aktualisieren» verdeckt; unter Dialogen (z-[60])
                <motion.div
                    initial={{ opacity: 0, y: 50, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 20, scale: 0.95 }}
                    transition={{ type: 'spring', stiffness: 400, damping: 25 }}
                    className="fixed bottom-6 right-6 z-[55] flex max-w-sm w-full flex-col gap-3 rounded-2xl bg-white p-5 shadow-2xl border border-blue-100 ring-1 ring-black/5"
                    role="alert"
                >
                    <div className="flex items-start justify-between gap-4">
                        <div className="flex items-center gap-3">
                            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-50">
                                <ArrowPathIcon className="h-6 w-6 text-blue-600 animate-spin-slow" aria-hidden="true" />
                            </div>
                            <div className="flex flex-col">
                                <h3 className="text-sm font-bold text-gray-900">
                                    {t('app.update.title', 'Neue Version verfügbar')}
                                </h3>
                                <p className="mt-1 text-sm text-gray-500 leading-relaxed">
                                    {t('app.update.description', 'Eine aktualisierte Version der CAF Suite steht bereit. Bitte speichern Sie Ihre Arbeit und aktualisieren Sie die App.')}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="inline-flex flex-shrink-0 rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={close}
                        >
                            <span className="sr-only">{t('common.close', 'Schliessen')}</span>
                            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                    
                    <div className="mt-2 flex gap-3">
                        <Button 
                            variant="secondary" 
                            className="flex-1"
                            onClick={close}
                        >
                            {t('app.update.later', 'Später')}
                        </Button>
                        <Button 
                            variant="primary" 
                            className="flex-1"
                            onClick={() => updateServiceWorker(true)}
                        >
                            {t('app.update.now', 'Jetzt aktualisieren')}
                        </Button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
